import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'

type ProgramAutonomousSystemPredictions = {
  predictions: { label: string }[]
}

export function useGetAutonomousSystemPredictions(programId?: string) {
  return useQuery({
    queryKey: ['autonomous-system-predictions', programId],
    queryFn: async () => {
      const { data } = await apiClient.get<ProgramAutonomousSystemPredictions>(
        `/int/v3/programs/${programId}/autonomous-system-predictions`
      )

      return data.predictions.map((p) => p.label)
    },
    enabled: Boolean(programId),
  })
}
